// Accept paths or the legacy public URL for this exact project/bucket only.
export function forumAttachmentPath(value, projectUrl) {
 if (typeof value !== 'string' || !value) return null;
 let path = value;
 if (/^[a-z][a-z0-9+.-]*:|^\//i.test(value)) {
  try {
   const url = new URL(value), project = new URL(projectUrl);
   const prefix = '/storage/v1/object/public/forum-attachments/';
   if (url.origin !== project.origin || !url.pathname.startsWith(prefix) || url.search || url.hash || url.username || url.password) return null;
   path = decodeURIComponent(url.pathname.slice(prefix.length));
  } catch { return null; }
 }
 return /^[0-9a-f-]{36}\/[^/]+$/i.test(path) && !path.includes('..') && !path.includes('\\') && !Array.from(path).some(character => character.charCodeAt(0) < 32) ? path : null;
}
